export default "__VITE_ASSET__Bz_EPqB6__"